export default function classnameToggle(el, name, add) {
  return el.classList[add ? 'add' : 'remove'](name);
}
